export enum UserType {
    EMPLOYEE = 'EMPLOYEE',
    LEARNER = 'LEARNER'
}